import { SsnCardVerification } from "../components/ssnCardVerification";

export function SsnCardVerificationPage() {
  return <SsnCardVerification />;
}
